import React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { StopPerformanceReviewProcessDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

export const StopReviewModal: React.FC<{
  reviewId: string
  onClose?: () => void
}> = ({ reviewId, onClose }) => {
  const [stopReviewMutation, { loading: stoppingReview }] = useMutation(
    StopPerformanceReviewProcessDocument,
    {
      extractorFn: (data) => data.performanceMutations.stopPerformanceReviewProcess,
    }
  )

  const stopReview = async () => {
    const response = await stopReviewMutation({
      variables: {
        id: String(reviewId),
      },
    })

    const result = handleResult(response, () => null)
    onClose?.()
    return result
  }

  return (
    <Modal
      title={i18n.t('performance_process.reviews.stop_review')}
      description={i18n.t('performance_process.reviews.stop_review_modal.description')}
      illustration={'alert'}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose} disabled={stoppingReview}>
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={() => stopReview()} disabled={stoppingReview}>
            {i18n.t('performance_process.reviews.stop_review')}
          </Button>
        </>
      }
    ></Modal>
  )
}
